var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import { Icon } from '@citrus/icon';
import { Textfield } from '@citrus/input-textfield';
import { useTheme } from '@citrus/user';
import { enterKeyPressed, keyPressed } from '@pcty/utils';
import { iconColor04 } from '../styles/citron';
var VERSION = '5.2.1';
var Search = function (_a) {
    var _b = _a["aria-label"], ariaLabel = _b === void 0 ? 'Search' : _b, autocomplete = _a.autocomplete, autocompleteOptions = _a.autocompleteOptions, _c = _a.autocompletePortal, autocompletePortal = _c === void 0 ? false : _c, _d = _a.autoFocus, autoFocus = _d === void 0 ? false : _d, automationId = _a.automationId, id = _a.id, className = _a.className, classNameWrapper = _a.classNameWrapper, css = _a.css, disabled = _a.disabled, emptyLabel = _a.emptyLabel, errorMessage = _a.errorMessage, footnote = _a.footnote, _e = _a.hideOptionalLabel, hideOptionalLabel = _e === void 0 ? false : _e, onChange = _a.onChange, _f = _a.performance, performance = _f === void 0 ? 'debounce' : _f, performanceTimeout = _a.performanceTimeout, placeholder = _a.placeholder, _g = _a.showRequiredLabel, showRequiredLabel = _g === void 0 ? false : _g, showValidationState = _a.showValidationState, tooltip = _a.tooltip, _h = _a.valid, valid = _h === void 0 ? true : _h, value = _a.value, _j = _a.__TYPE, TYPE = _j === void 0 ? 'Search' : _j, other = __rest(_a, ['aria-label', "autocomplete", "autocompleteOptions", "autocompletePortal", "autoFocus", "automationId", "id", "className", "classNameWrapper", "css", "disabled", "emptyLabel", "errorMessage", "footnote", "hideOptionalLabel", "onChange", "performance", "performanceTimeout", "placeholder", "showRequiredLabel", "showValidationState", "tooltip", "valid", "value", "__TYPE"]);
    var theme = useTheme();
    var _onChange = useCallback(function (event) {
        var _a;
        var value = (_a = event.value) === null || _a === void 0 ? void 0 : _a.toString();
        if (onChange) {
            onChange({ id: id, value: value, e: event.e });
        }
    }, [id, onChange]);
    var onKeyPress = useCallback(function (e) {
        var _a, _b;
        if (enterKeyPressed(e)) {
            _onChange({
                id: id,
                value: (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value,
                eventType: 'change',
                forceNotify: false,
                autocompleted: false,
                e: e,
            });
            e.preventDefault();
        }
        if (keyPressed(e, ['Tab'])) {
            _onChange({
                id: id,
                value: (_b = e === null || e === void 0 ? void 0 : e.target) === null || _b === void 0 ? void 0 : _b.value,
                eventType: 'change',
                forceNotify: false,
                autocompleted: false,
                e: e,
            });
        }
    }, [_onChange, id]);
    return (React.createElement(Textfield, __assign({}, other, { ariaLabel: ariaLabel, autoFocus: autoFocus, autocomplete: autocomplete, autocompleteOptions: autocompleteOptions, autocompletePortal: autocompletePortal, automationId: automationId, className: className, classNameWrapper: classNameWrapper, clearable: true, css: css, disabled: disabled, emptyLabel: emptyLabel, errorMessage: errorMessage, footnote: footnote, hideOptionalLabel: hideOptionalLabel, id: id, maxLength: 9999, onChange: _onChange, onKeyDown: onKeyPress, performance: performance, performanceTimeout: performanceTimeout, placeholder: placeholder, preventAutoFill: true, readOnly: false, renderIcon: function () { return React.createElement(Icon, { "aria-label": "search", color: theme.legacy ? 'blue' : iconColor04, name: "search" }); }, showRequiredLabel: showRequiredLabel, showValidationState: showValidationState, tooltip: tooltip, valid: valid, value: value })));
};
Search.defaultProps = {
    'aria-label': 'Search',
    emptyLabel: false,
    __TYPE: 'Search',
};
export default Search;
